// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2W1zi","content":"LoadingAlert_content__19YbB"};